import { type CMSData, type Content } from '@/features/cms/components/CMS/types'
import { isPageLayoutWithBody } from '@/features/cms/components/CMS/utils/typeGuards'

export const getBodyContentWithLayoutGroupChildren = (cmsData: CMSData | undefined): Content[] => {
  if (!isPageLayoutWithBody(cmsData)) {
    return []
  }

  const bodyContent = cmsData.content.data.body ?? []
  return bodyContent.flatMap((item) =>
    item.content_type_id === 'layout_group' ? (item.data?.children ?? []) : [item],
  )
}
